const chainNameBySymbol: Record<string, string> = {
  BTC: 'Bitcoin',
  'LN-BTC': 'Lightning',
  ETH: 'Ethereum',
  BASE: 'Base',
  ESDT: 'Elrond',
  BSC: 'BNB Smart Chain',
  DASH: 'Dash',
  ERD: 'MultiversX',
  POLYGON: 'Polygon',
  MATIC: 'Polygon',
  TRX: 'Tron',
  SUI: 'Sui',
  HEDERA: 'Hedera',
  SOL: 'Solana Pay',
  SOLANA: 'Solana',
  WalletConnectPay: 'WalletConnect Pay',
};

export default chainNameBySymbol;
